export const NOT_CLOSING  = 'sgc-dropdown-not_closing';
export const CLOSING      = 'sgc-dropdown-closing';
export const MENU         = 'sgc-dropdown-menu';
export const SUBMENU      = 'sgc-dropdown-submenu';
export const MENU_CONTENT = 'sgc-dropdown-menu-content';
export const SHOW         = 'open';
